import { createReducerFromMap } from "@coverme/redux";

const initialState = {
    isObtainingProgramSpecificInterviewSections: false,
    hasObtainedProgramSpecificInterviewSections: false,
};

function startObtainingProgramSpecificSections(state, action) {
    return {
        ...state,
        isObtainingProgramSpecificInterviewSections: true,
        hasObtainedProgramSpecificInterviewSections: false,
    };
}

function getEligibleProgramsComplete(state, action) {
    return {
        ...state,
        isObtainingProgramSpecificInterviewSections: false,
        hasObtainedProgramSpecificInterviewSections: true,
    };
}

function resetInterview(state, action) {
    return initialState;
}

export const interviewProgramReducer = createReducerFromMap(initialState, {
    GET_ELIGIBLE_PROGRAMS_START: startObtainingProgramSpecificSections,
    GET_ELIGIBLE_PROGRAMS_COMPLETE: getEligibleProgramsComplete,
    GET_PROGRAM_SPECIFIC_SECTIONS_START: startObtainingProgramSpecificSections,
    GET_PROGRAM_SPECIFIC_SECTIONS_COMPLETE: getEligibleProgramsComplete,
    GET_PROGRAM_SPECIFIC_SECTIONS_FAIL: () => console.warn("Unable to obtain specific sections"),
    RESET_INTERVIEW: resetInterview,
});
